import { TicketActions, TicketEditorNoteFormProps } from '@/routes/tickets/TicketEditor.types'
import {
  ButtonItem,
  ButtonOptions,
  Form as DXForm,
  FormRef,
  GroupItem,
  RequiredRule,
  SimpleItem,
} from 'devextreme-react/form'
import { useRef } from 'react'
import { ClickEvent } from 'devextreme/ui/button'
import { FileUploader } from 'devextreme-react'
import { onInitializedHtmlEditor, onValueChangedHtmlEditor, toolbarHtmlEditor } from '@/routes/utils'
import { FileUploaderRef } from 'devextreme-react/file-uploader'
import { FieldDataChangedEvent } from 'devextreme/ui/form'
import { useScreenSize } from '@/themes/media-query'
import './TicketEditor.note.scss'

const TicketEditorNoteForm = (props: TicketEditorNoteFormProps) => {
  const { note, action, readOnly, onSaveClick, onDraftChanged, isSubmitting, height } = props
  const ref = useRef<FormRef>(null)
  const fileUploaderRef = useRef<FileUploaderRef>(null)
  const currentScreenSize = useScreenSize()
  const saveButtonIcon =
    action === TicketActions.SendTicketNote ? 'email' : action === TicketActions.CreateTicketNote ? 'comment' : 'save'
  let saveButtonText = 'Salva'
  if (action === TicketActions.SendTicketNote) saveButtonText = isSubmitting ? 'Invio...' : 'Invia'
  else if (action === TicketActions.CreateTicketNote) saveButtonText = isSubmitting ? 'Creazione...' : 'Crea'
  else if (isSubmitting) saveButtonText = 'Salvataggio...'

  return (
    <>
      <div className="note-form">
        <DXForm
          formData={note}
          id={`ticket_action_form_${action}`}
          labelLocation={'top'}
          showValidationSummary={true}
          validationGroup={`ticketActionPopupValidation_${action}`}
          ref={ref}
          onFieldDataChanged={(e: FieldDataChangedEvent) => {
            if (e.dataField === 'testo') {
              onDraftChanged?.((e.value as string | null | undefined) ?? null)
            }
            if (
              ref.current?.instance().option().isDirty !== null &&
              ref.current?.instance().option().isDirty !== undefined
            ) {
              ref.current
                .instance()
                .getButton('btn-save')
                ?.option('disabled', !ref.current?.instance().option().isDirty)
            }
          }}
        >
          <GroupItem colCount={1}>
            <SimpleItem
              dataField="testo"
              label={{ visible: false }}
              editorType="dxHtmlEditor"
              editorOptions={{
                stylingMode: 'filled',
                valueType: 'html',
                toolbar: toolbarHtmlEditor(currentScreenSize),
                readOnly: readOnly || isSubmitting,
                mediaResizing: {
                  enabled: true,
                },
                imageUpload: {
                  tabs: ['file', 'url'],
                  fileUploadMode: 'base64',
                },
                height: height,
                onValueChanged: onValueChangedHtmlEditor,
                onInitialized: onInitializedHtmlEditor,
              }}
            >
              <RequiredRule message="Testo obbligatorio"></RequiredRule>
            </SimpleItem>
          </GroupItem>
          <GroupItem>
            {(action === TicketActions.CreateTicketNote || action === TicketActions.SendTicketNote) && (
              <FileUploader
                disabled={readOnly || isSubmitting}
                ref={fileUploaderRef}
                name={'note_files'}
                selectButtonText={'Seleziona i files'}
                labelText={'o trascina i files qui'}
                multiple={true}
                accept={'*'}
                uploadMode="useButtons"
                readyToUploadMessage=""
                allowedFileExtensions={[]}
                maxFileSize={action === TicketActions.SendTicketNote ? 31_457_280 : 104_857_600}
                invalidMaxFileSizeMessage={
                  action === TicketActions.SendTicketNote
                    ? 'File troppo grande: limite 30MB'
                    : 'File troppo grande: limite 100MB'
                }
              />
            )}
          </GroupItem>
          <GroupItem cssClass="last-group">
            <GroupItem cssClass="buttons-group" colCount={1}>
              <ButtonItem name="btn-save">
                <ButtonOptions
                  disabled={readOnly || !!isSubmitting || !ref.current?.instance().option().isDirty}
                  icon={saveButtonIcon}
                  text={saveButtonText}
                  width="150px"
                  onClick={(e: ClickEvent) => {
                    if (isSubmitting) return
                    const validationResult = ref.current?.instance().validate()
                    if (!validationResult?.isValid) return
                    onSaveClick(fileUploaderRef.current?.instance().option().value)
                  }}
                />
              </ButtonItem>
            </GroupItem>
          </GroupItem>
        </DXForm>
      </div>
    </>
  )
}

export default TicketEditorNoteForm
